import { makeStyles, Theme, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textLengthContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    currentTextLength: {
      color: theme.palette.text.primary,
      marginTop: theme.spacing(1),
    },
    maxTextLength: {
      color: theme.palette.text.secondary,
      marginTop: theme.spacing(1),
    },
  }),
);

export default useStyles;
